
































































import { Component, Prop } from "vue-property-decorator";
import { ICodeList, IMapFilter } from "@/components/map/types";
import Map from "@/components/map/Map";
import SearchBase from "./search.base";

import { APP_URL } from "@/common/http";
import { L } from "@/common/filters";

@Component
export default class DownloadLand extends SearchBase {
  @Prop({
    default: null
  }) data: {
    $map: Map;
    filter: IMapFilter
  };
  
  created() {
    this.autoFilter = true;
    this.fetchProvinces();
    if (this.data) {
      this.$map = this.data.$map;
      if (this.data.filter) {
        this.filter = this.data.filter; //IMPORTANT: to make them the same instance
        let keepThese = ['ProvinceCode','AmphoeCode','TambonCode'];
        for (let p in this.filter) {
          if (keepThese.indexOf(p)==-1) {
            if (p=='Source') {
              this.filter.Source = 'GISagro'; //IMPORTANT: required for filter by Tambon
            } else if (p=='Area1' || p=='Area2') {
              this.filter[p] = {
                Rai: null,
                Ngan: null,
                SqWah: null
              } 
            } else {
              this.filter[p] = null;
            }
          }
        }
        if (this.filter.ProvinceCode) {
          this.fetchAmphoes();
          if (this.filter.AmphoeCode) {
            this.fetchTambons();
          }
        }
        this.setFilter();
      }
    }
  }
  
  get ShapeFileDownloadUrl() : string {
    // IMPORTANT: 
    // outputFormat=SHAPE-ZIP must be in UPPERCASE
    // use WFS version 1.0.0 instead of 1.1.0. They specify different
    // coordinate order for ESPG:4326. The former is long/lat, the later is lat/long
    let adminCode:number;
    let fileName:string = 'gisagro';
    let adminAreas:ICodeList[][] = [];
    if (this.filter) {
      if (this.filter.TambonCode) {
        adminCode = this.filter.TambonCode;
        adminAreas = [this.srhProvinces, this.srhAmphoes, this.srhTambons];
      } else if (this.filter.AmphoeCode) {
        adminCode = this.filter.AmphoeCode;
        adminAreas = [this.srhProvinces, this.srhAmphoes];
      } else if (this.filter.ProvinceCode) {
        adminCode = this.filter.ProvinceCode;
        adminAreas = [this.srhProvinces];
      }
      fileName = '';
      adminAreas.forEach((aa,i) => {
        let c = (adminCode+'').substring(0,(i+1) * 2);
        for (let j=0; j<this.srhProvinces.length; j++) {
          if (aa[j].code==c) {
            let an = aa[j].name_en.replace(/\s+/g,'-').toCamelCase(); //issue: not support Thai
            an = an.substring(0,1).toUpperCase() + an.substring(1);
            fileName += (i>0 ? '_' : '') + an;
            break;
          }
        }
      });
    }
    fileName += '.zip';
    //fileName = "utf-8''" + encodeURIComponent(fileName);
    let wfs = APP_URL + '/rest/gis/wfs?service=WFS&version=1.0.0'; 
    wfs += '&request=GetFeature&typeName=gisagro:download_gisagro';
    wfs += '&outputFormat=SHAPE-ZIP&format_options=CHARSET:UTF-8;filename:' + fileName;
    // propertyName must include geometry field
    //wfs += '&propertyName=gid,geom,province,amphoe,tambon,type_th,genus_th,crop_th,';
    //wfs += 'fssn_fk,title_th,name_th,surname_th,';
    //wfs += 'deed_no,deed_type,ownership,irrigation,org_code,org_key,user_fk'; //,user_name,user_surname';
    wfs += '&APIID=th.co.softoo.rest&viewparams=ac:' + adminCode;
    
    if (this.User && this.User.hasLoggedIn) {
      wfs += ';un:' + this.User.Code;
    }
    return wfs;
  }

  /*get OLDShapeFileDownloadUrl() : string {
    // IMPORTANT: 
    // outputFormat=SHAPE-ZIP must be in UPPERCASE
    // use WFS version 1.0.0 instead of 1.1.0. They specify different
    // coordinate order for ESPG:4326. The former is long/lat, the later is lat/long
    let wfs = APP_URL + '/rest/gis/wfs?service=WFS&version=1.0.0'; 
    wfs += '&request=GetFeature&typeName=gisagro:gisagro';
    wfs += '&outputFormat=SHAPE-ZIP&format_options=CHARSET:UTF-8;filename:gisagro.zip';
    // propertyName must include geometry field
    wfs += '&propertyName=geom,idcard,prefix,firstname,surname,pla_type,pla_detail,pla_breed,';
    wfs += 't_name,a_name,p_name,doc_no,doc_type,area_type,wc_name,org_code,org_key';
    wfs += '&APIID=th.co.softoo.rest&cql_filter=';
    let and = '';
    if (this.srhSelectedTambon) {
      wfs += 'aag5_fk=' + this.srhSelectedTambon;
      and = ' AND ';
    } else if (this.srhSelectedAmphoe) {
      wfs += 'aag4_fk=' + this.srhSelectedAmphoe;
      and = ' AND ';
    } else if (this.srhSelectedProvince) {
      wfs += 'aag3_fk=' + this.srhSelectedProvince;
      and = ' AND ';
    }
    if (this.User.Organization && this.User.Organization.Code) {
      wfs += and + '(org_code=\'' + this.User.Organization.Code + '\' OR org_code=\'GISTDA\')';
    } else {
      wfs += and + 'org_code IS NULL';
    }
    return wfs;
  }*/
}
